module.exports = __webpack_public_path__ + "media/images/flags/4x3/bol-82720b03a4a36e65ac673be8bd2330fc.svg";